import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const POSOrderListPage = () => {
    const [posOrders, setPosOrders] = useState([]);
    const [filteredPosOrders, setFilteredPosOrders] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch POS orders data from API
    useEffect(() => {
        fetch(`${BASE_URL}posorders`)
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    setPosOrders(data.data || []);
                    setFilteredPosOrders(data.data || []);
                }
            })
            .catch(error => console.error('Error fetching POS orders data:', error));
    }, []);

    // Search filter
    const handleSearchChange = (event) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);
        const filtered = posOrders.filter((order) =>
            order.item_barcode.toLowerCase().includes(term) ||
            order.remark.toLowerCase().includes(term) ||
            order.brand.toLowerCase().includes(term)
        );
        setFilteredPosOrders(filtered);
    };

    // Navigate to edit POS order page
    const handleEdit = (id) => {
        navigate(`/POSOrderEditPage/${id}`);
    };

    // Handle delete POS order
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this POS order?")) {
            fetch(`${BASE_URL}posorders/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === "success") {
                        setPosOrders(posOrders.filter((order) => order.id !== id));
                        setFilteredPosOrders(filteredPosOrders.filter((order) => order.id !== id));
                        alert("POS Order deleted successfully!");
                    } else {
                        alert("Failed to delete POS Order.");
                    }
                })
                .catch(error => console.error('Error deleting POS Order:', error));
        }
    };

    // Navigate to add POS order page
    const handleAdd = () => {
        navigate('/POSOrderAddPage');
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>POS Order List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Table Section */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="search" className="form-label">Search</label>
                                        <input
                                            type="text"
                                            id="search"
                                            className="form-control"
                                            placeholder="Search by item barcode, remark, or brand"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add POS Order</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>Item Barcode</th>
                                                <th>Pack Unit</th>
                                                <th>Quantity</th>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                                <th>Tax Code</th>
                                                <th>Brand</th>
                                                <th>Remark</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredPosOrders.map((order) => (
                                                <tr key={order.id}>
                                                    <td>{order.item_barcode}</td>
                                                    <td>{order.pack_unit}</td>
                                                    <td>{order.quantity}</td>
                                                    <td>{order.rate}</td>
                                                    <td>{order.amount}</td>
                                                    <td>{order.taxcode}</td>
                                                    <td>{order.brand}</td>
                                                    <td>{order.remark}</td>
                                                    <td>
                                                        <button className="btn btn-success" onClick={() => handleEdit(order.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(order.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default POSOrderListPage;
